import { Warp, WarpsData } from "../types/Warps";
import { Packet } from "./Packet";
import { PacketType } from "./PacketType";

export const getDisconnectPacket = (
  token: string,
): Packet<PacketType.INBOUND_CLIENT_DISCONNECT> => {
  return {
    type: PacketType.INBOUND_CLIENT_DISCONNECT,
    token: token,
  };
};
export const getConnectionPacket = (
  token: string,
): Packet<PacketType.INBOUND_CLIENT_CONNECTION> => {
  return {
    type: PacketType.INBOUND_CLIENT_CONNECTION,
    token: token,
  };
};

export const getWarpPacket = (
  token: string,
  warp: Warp,
): Packet<PacketType.INBOUND_CLIENT_WARP> => {
  return {
    type: PacketType.INBOUND_CLIENT_WARP,
    token: token,
    name: warp.name,
    x: warp.pos_x,
    y: warp.pos_y,
    z: warp.pos_z,
    yaw: warp.yaw,
    pitch: warp.pitch,
  };
};
